module.exports = __webpack_public_path__ + "static/media/A1_Logo_Similar_Omega_Detail_Screen.aa416c1c.jpg";